var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 13L4.08824 13C3.68268 13 3.2811 12.9224 2.90642 12.7716C2.53174 12.6209 2.19129 12.3999 1.90452 12.1213C1.61775 11.8427 1.39028 11.512 1.23508 11.1481C1.07988 10.7841 1 10.394 1 10C1 9.60603 1.07988 9.21593 1.23508 8.85195C1.39028 8.48797 1.61775 8.15726 1.90452 7.87868C2.19129 7.6001 2.53174 7.37913 2.90642 7.22836C3.2811 7.0776 3.68268 7 4.08824 7L12.0294 7C12.8485 7 13.634 6.68393 14.2131 6.12132C14.7923 5.55871 15.1176 4.79565 15.1176 4C15.1176 3.20435 14.7923 2.44129 14.2131 1.87868C13.634 1.31607 12.8485 1 12.0294 1L1.44118 1M16 13L12.9118 16M16 13L12.9118 10",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.53e09102ec63df2f6dc4262d10090e5a.svg";
export { ForwardRef as ReactComponent };